const states = new WeakMap();
export class LeaveCheckForm extends HTMLElement {
    constructor() {
        super(...arguments);
        this.init = () => {
            const formDataJson = this.formDataJson;
            if (!formDataJson)
                return;
            this.state = { formDataJson };
        };
        this.onBeforeUnload = (event) => {
            if (this.state.isSubmitting || this.state.formDataJson === this.formDataJson) {
                return;
            }
            event.preventDefault();
            event.returnValue = '';
        };
        this.onSubmit = () => {
            var _a;
            if (!((_a = this.form) === null || _a === void 0 ? void 0 : _a.checkValidity()))
                return;
            this.state = Object.assign(Object.assign({}, this.state), { isSubmitting: true });
        };
    }
    connectedCallback() {
        requestAnimationFrame(() => this.init());
        window.addEventListener('beforeunload', this.onBeforeUnload);
        this.addEventListener('submit', this.onSubmit);
    }
    disconnectedCallback() {
        window.removeEventListener('beforeunload', this.onBeforeUnload);
        this.removeEventListener('submit', this.onSubmit);
    }
    get state() {
        var _a;
        return (_a = states.get(this)) !== null && _a !== void 0 ? _a : {};
    }
    set state(newState) {
        states.set(this, newState);
    }
    get form() {
        var _a;
        return (_a = this.querySelector('form')) !== null && _a !== void 0 ? _a : undefined;
    }
    get formDataJson() {
        if (!this.form)
            return undefined;
        const formData = new FormData(this.form);
        return JSON.stringify(Array.from(formData.entries()));
    }
}
if (!window.customElements.get('leave-check-form')) {
    window.LeaveCheckForm = LeaveCheckForm;
    window.customElements.define('leave-check-form', LeaveCheckForm);
}
